// extracted by mini-css-extract-plugin
module.exports = {"lia-edit-btn":"FeaturedIdeaStatusesWidget_lia-edit-btn__qBVn0"};